import { breakpoints } from "@/utils/breakpoints/breakpoints";
import { Flex } from "antd";
import { styled } from "styled-components";

const HeroStyled = styled(Flex)`
    display: flex;
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    gap: 24px;
    box-sizing: border-box;
    @media (max-width: ${breakpoints.lg}) {
        max-width: 100%;
        padding: 32px 16px;
    }
`;

const BodyHeroStyled = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr minmax(1fr, 360px);
    grid-template-areas: 
    "title image"
    "description image";
    gap: 16px;
    justify-content: center;
    align-items: center;
    @media (max-width: ${breakpoints.md}) {
        grid-template-columns: 1fr;
        grid-template-areas: 
        "title"
        "description"
        "image";
        gap: 16px;
        text-align: center;
    }
`;

const TitleHeroStyled = styled.div`
    grid-area: title;
    align-self: end;
    justify-self: start;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    width: 100%;
    text-align: left;

    @media (max-width: ${breakpoints.md}) {
        justify-self: center;
        text-align: center;
        p {
            text-align: center !important;
            margin: 0 auto !important;
            max-width: 100% !important;
        }
    }
`;

const DescriptionHeroStyled = styled.div`
    grid-area: description;
    align-self: start;
    justify-self: start;
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    width: 100%;
    text-align: left;

    @media (max-width: ${breakpoints.md}) {
        justify-self: center;
        text-align: center;
        
        p {
            text-align: center !important;
            margin: 0 auto !important;
            max-width: 100% !important;
        }
    }
`;

const ImageHeroStyled = styled.div`
    grid-area: image;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    
    @media (max-width: ${breakpoints.md}) {

        margin: 0 auto;
    }
`;

export {
    HeroStyled,
    BodyHeroStyled,
    TitleHeroStyled,
    DescriptionHeroStyled,
    ImageHeroStyled,
};
